module.exports = __webpack_public_path__ + "img/48.ea5f8163.jpeg";